module.exports = __webpack_public_path__ + "static/media/done.3fe7db2f.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/workout/done.mp3
// module id = 2030
// module chunks = 0